import { gql, TypedDocumentNode } from '@apollo/client';
import { DesignerQuery, DesignerQueryVariables } from '../../generated/types/DesignerQuery';
import { useSkippableQuery } from '../useSkippableQuery';

export const DESIGNER_QUERY: TypedDocumentNode<DesignerQuery, DesignerQueryVariables> = gql`
  query DesignerQuery($slug: String!) {
    designer(slug: $slug) {
      id
      name
      slug
    }
  }
`;

export const useDesigner = (slug?: string) => {
  const { data, loading, error } = useSkippableQuery(DESIGNER_QUERY, {
    variables: {
      slug
    },
    skip: !slug
  });

  return {
    designer: data?.designer,
    loading,
    error
  };
};
